/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';
import RedirectForLoggedOut from '@xanadu/ui-shared/components/RedirectForLoggedOut';
import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncGeneralSettings = async(() =>
  import('@xanadu/ui-shared/components/AccountPage/components/GeneralSettings').then(
    (module) => module.default
  )
);

const AsyncResponsibleGambling = async(() =>
  import('@xanadu/ui-shared/components/AccountPage/components/ResponsibleGambling').then(
    (module) => module.default
  )
);

const AsyncAccountBalances = async(() =>
  import('../components/account/Account').then((module) => module.default)
);

const AsyncAccountVerification = async(
  () =>
    import('@xanadu/ui-shared/components/AccountPage/components/AccountVerification').then(
      (module) => module.default
    ),
  'AccountVerification'
);

const AsyncAccountIntegrations = async(
  () =>
    import('@xanadu/ui-shared/components/AccountPage/components/Integrations').then(
      (module) => module.default
    ),
  'AccountIntegrations'
);

const AsyncAccountPage = async(() =>
  import('@xanadu/ui-shared/components/AccountPage').then((module) => module.default)
);

const components = {
  'account-balances': AsyncAccountBalances,
  'general-settings': AsyncGeneralSettings,
  'safer-gambling': () => <AsyncResponsibleGambling netDepositLayoutDirection={'vertical'} />,
  verification: AsyncAccountVerification,
  integrations: AsyncAccountIntegrations,
};

const AccountPage = ({ tabs }) => (
  <React.Fragment>
    <GlobalBannerPortal withTabs />
    <RedirectForLoggedOut />
    <Switch>
      <Redirect exact from="/account/" to="/account/account-balances" />
      <AsyncAccountPage tabs={tabs}>
        {tabs
          .filter((tab) => components[tab.key])
          .map((tab) => (
            <Route key={tab.key} path={tab.href} component={components[tab.key]} />
          ))}
      </AsyncAccountPage>
    </Switch>
  </React.Fragment>
);

AccountPage.propTypes = {
  tabs: PropTypes.array.isRequired,
};

export default AccountPage;
